import { writable } from "svelte/store";

export const popup = writable<{timerId: NodeJS.Timeout | number | null}>({timerId: null});

export function cancelPopUp() {
  popup.update(p => {
    if (p.timerId) {
      clearTimeout(p.timerId as number);
    }
    return {...p, timerId: null};
  });
}
